import { render } from "./App.vue?vue&type=template&id=0bf650f8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0bf650f8&lang=css"

import exportComponent from "/var/www/sw/smith-wesson/sites/all/themes/smith_wesson/assets/vh-assets/jsvue/dealerapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__